import { render, staticRenderFns } from "./activityReview.vue?vue&type=template&id=27532c6a&scoped=true&"
import script from "./activityReview.vue?vue&type=script&lang=js&"
export * from "./activityReview.vue?vue&type=script&lang=js&"
import style0 from "./activityReview.vue?vue&type=style&index=0&id=27532c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27532c6a",
  null
  
)

export default component.exports